import { styled } from '@mui/material';

export const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
`;
